import { Controller } from "stimulus";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";

export default class extends Controller {
  connect() {
    this.form = document.querySelector(this.element.dataset.formTarget);

    if (!this.form)
      return;

    this.form.addEventListener('turbo:submit-end', (ev) => {
      AjaxLoader.hide();
    });

    $(this.element.querySelectorAll('input')).on('keypress',  (ev) => {
      console.log('ev.code:', ev.code)
      if (ev.code === 'NumpadEnter' || ev.code === 'Enter') {
        AjaxLoader.show();
        this.form.submit();
      }
    });
  }
};